"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ifFeature = ifFeature;
var _isEnabled = require("./is-enabled");
/**
 * Checks if a feature is enabled and returns the corresponding argument.
 *
 * @example
 *
 * // returns `a` if feature is enabled, `b` if feature is disabled
 * ifFeature('MY_FEATURE', 'a', 'b');
 *
 * // returns `true` if feature is enabled, `undefined` if feature is disabled
 * ifFeature('MY_FEATURE', true);
 *
 * @param featureName The feature to check.
 * @param enabledResult What to return if your feature is enabled.
 * @param disabledResult What to return if your feature is disabled. If not provided and the feature is disabled, `undefined` will be returned.
 */

function ifFeature(featureName, enabledResult, disabledResult) {
  return (0, _isEnabled.isEnabled)(featureName) ? enabledResult : disabledResult;
}